import React from 'react';
import '../../styles/styles.css';

export default function tirupati() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/tirupati.jpg" alt="Srinivasa" />    
            </div>

            {/* Right Information Boxes */}
          
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>December Special Darshan Ticket Online Booking Date<br />
    24th September, 2025<br />    
    <br />

  </strong></p>
  <p>Registration link to Special Entry Darshan : <a href="https://ttdevasthanams.ap.gov.in/home/dashboard" target="_blank" rel="noopener noreferrer">
  TTD Registration
</a>
  </p>
 </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Lord Sri Venkateswara, also known as Srinivasa, Balaji, and Veṅkaṭachalapati, made Tirumala his abode five thousand years ago. Even before him, it was Lord Varahaswami who had made Tirumala his abode. Since then, many devotees have continued to construct grand entrances on the ramparts of the temple over generations. The temple complex is spread over 16.2 acres of land.</p>
            </div>
        </div>

        {/* YouTube Section */}
      <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Darshan Live Streaming</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/hk4qHh5W2BA?rel=0&modestbranding=1&showinfo=0"
                title="Tirupati Live"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
